<script setup lang="ts">
import {computed} from "vue";
import {DashboardWidgetProps} from "@/utils/presenters/interfaces.ts";
import DTOBIChartLine = namaTypes.DTOBIChartLine;

const props = defineProps<DashboardWidgetProps>();

const biChartLine = computed<DTOBIChartLine>(() => props.chartLine as DTOBIChartLine);
const data = computed<Record<string, any>>(() => (biChartLine.value?.textBlockData ?? {}) as Record<string, any>);

const html = computed<string>(() => (data.value.html as string) ?? '');

const frameStyle = computed<Record<string, string>>(() => {
  const d = data.value;
  const style: Record<string, string> = {};
  if (d.bgColor) style.backgroundColor = String(d.bgColor);
  if (d.color) style.color = String(d.color);
  if (d.padding) style.padding = String(d.padding);
  if (d.borderColor) {
    style.border = `${d.borderWidth ?? '1px'} solid ${d.borderColor}`;
  } else if (d.borderWidth) {
    style.border = `${d.borderWidth} solid currentColor`;
  }
  if (d.borderRadius) style.borderRadius = String(d.borderRadius);
  if (d.textAlign) style.textAlign = String(d.textAlign);
  if (d.fontSize) style.fontSize = String(d.fontSize);
  return style;
});
</script>

<template>
  <div class="tw-h-full tw-w-full tw-overflow-auto" :style="frameStyle">
    <div v-html="html" class="nama-textblock-content"/>
  </div>
</template>

<style>
.nama-textblock-content {
  word-break: break-word;
}
.nama-textblock-content :first-child { margin-top: 0; }
.nama-textblock-content :last-child { margin-bottom: 0; }
</style>
